import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Constante } from '../../constante';
import { CapacidadApi, RangoHorarioApi } from '../models/api/empresa-api';
import { ResponseApi } from '../models/response-api';
import { AppUtil } from '../utility/app-util';

@Injectable({ providedIn: 'root' })
export class CapacidadService {
    private http = inject(HttpClient);
    private url = AppUtil.addTrailingSlash(environment.URL_API_PEDIDOS) + 'api/capacidad/';

    listRangosHorario(): Observable<RangoHorarioApi[]> {
        return this.http.get<ResponseApi<RangoHorarioApi[]>>(this.url + 'list-rangos-horario').pipe(
            map((res) => (res.success === Constante.REQUEST_STATUS_OK && Array.isArray(res.data) ? res.data : []))
        );
    }

    listCapacidades(desde: string, hasta: string): Observable<CapacidadApi[]> {
        const params = new HttpParams().set('desde', desde).set('hasta', hasta);
        return this.http.get<ResponseApi<CapacidadApi[]>>(this.url + 'list-capacidades', { params }).pipe(
            map((res) => (res.success === Constante.REQUEST_STATUS_OK && Array.isArray(res.data) ? res.data : []))
        );
    }

    updateCapacidad(body: { rangoHorarioUuid: string; fecha: string; capacidadMaxima: number }): Observable<boolean> {
        return this.http.put<ResponseApi<unknown>>(this.url + 'update-capacidad', body).pipe(
            map((res) => res.success === Constante.REQUEST_STATUS_OK)
        );
    }

    updateRangoHorario(uuid: string, body: {
        nombre: string;
        horaInicio: string;
        horaFin: string;
        horaCierrePedidos: string;
        capacidadDefault: number;
        orden: number;
    }): Observable<boolean> {
        return this.http.put<ResponseApi<unknown>>(this.url + 'update-rango-horario/' + uuid, body).pipe(
            map((res) => res.success === Constante.REQUEST_STATUS_OK)
        );
    }
}
